import { cn } from 'utils/cn';
import { Avatar } from '../Avatar';
import { CustomItemProps } from '../MultiSelect';

const CustomSelectItem = ({ option, selected, disabled }: CustomItemProps) => {
    return (
        <div
            className={cn(
                'flex items-center gap-2 p-1',
                selected && 'bg-primary/10',
                disabled && 'opacity-50'
            )}
        >
            <Avatar
                size="sm"
                title={option.label}
                src={option.src as string}
                email={option.email as string}
            />
            <div>
                <div className="font-medium">{option.label}</div>
                <div className="text-sm text-muted-foreground">{option.description}</div>
            </div>
        </div>
    );
};

export default CustomSelectItem;

CustomSelectItem.displayName = 'CustomSelectItem';